<template>
  <confirm-modal
    :options="confirmOptions"
    :show="visible"
    @closeConfirm="closeConfirm"
  >
    <div
      slot="content"
      ref="uploadFileRef"
      id="uploadFileRef"
      class="upload-file-modal"
    >
      <!-- <h3 class="fs-bs f-bold">Attach Your PCB Files:</h3> -->
      <h3 class="fs-bs f-bold">
        {{ MLANG.never_disclose_file }}
      </h3>
      <p class="fc-bs">
        {{ MLANG.pcb_bom_file_format }}
      </p>
      <p class="order-no">
        <template v-if="params.page === 'cart'">
          <span v-if="params.smt_order_id"
            >PCB Assembly Order No.:{{ params.smt_order_id }}</span
          >
          <span v-if="params.pcb_order_id"
            >PCB Order No.:{{ params.pcb_order_id }}</span
          >
          <span v-if="params.bom_order_id"
            >BOM Order No.:{{ params.bom_order_id }}</span
          >
        </template>
      </p>
      <!-- 上传文件按钮 -->
      <div class="upload-file-btn-box">
        <div class="upload-btn-wrap">
          <!-- gerber file上传按钮 -->
          <div v-if="pcbFile.name" class="upload-btn disabled-upload-btn">
            <i class="icon mg-r-sm pd-r-xs upload-icon">&#xe632;</i>
            <span>{{ MLANG.upload_gerbers_file }}</span>
          </div>
          <np-upload
            v-else-if="smtShow || pcbShow"
            ref="pcbFileUploadRef"
            @onprogress="upfileProgress"
            :opts="pcbUploadOpts"
            @success="(fileData) => fileUploadSuccess(fileData, 'pcbFile')"
          >
            <div slot="btn" class="upload-btn pcb-upload-btn">
              <i class="icon mg-r-sm pd-r-xs upload-icon">&#xe632;</i>
              <span>{{ MLANG.upload_gerbers_file }}</span>
            </div>
          </np-upload>
          <!-- bom file上传按钮 -->
          <div v-if="bomFile.name" class="upload-btn disabled-upload-btn">
            <i class="icon mg-r-sm pd-r-xs upload-icon">&#xe632;</i>
            <span>{{ MLANG.upload_part_file }}</span>
          </div>
          <np-upload
            v-else-if="smtShow || bomShow"
            ref="bomFileUploadRef"
            @onprogress="upfileProgress"
            :opts="bomUploadOpts"
            @success="(fileData) => fileUploadSuccess(fileData, 'bomFile')"
          >
            <div slot="btn" class="upload-btn bom-upload-btn">
              <i class="icon mg-r-sm pd-r-xs upload-icon">&#xe632;</i>
              <span>{{ MLANG.upload_part_file }}</span>
            </div>
          </np-upload>
          <!-- Centroid file上传按钮 -->
          <div
            v-if="centroidFile.name"
            class="upload-btn disabled-upload-btn"
          >
            <i class="icon mg-r-sm pd-r-xs upload-icon">&#xe632;</i>
            <span>{{ MLANG.upload_centroid_file }}</span>
          </div>
          <np-upload
            v-else-if="smtShow"
            ref="centroidFileUploadRef"
            @onprogress="upfileProgress"
            :opts="centroidUploadOpts"
            @success="
              (fileData) => fileUploadSuccess(fileData, 'centroidFile')
            "
          >
            <div slot="btn" class="upload-btn centroid-upload-btn">
              <i class="icon mg-r-sm pd-r-xs upload-icon">&#xe632;</i>
              <span>{{ MLANG.upload_centroid_file }}</span>
            </div>
          </np-upload>
        </div>
        <!-- 上传文件显示 -->
        <div>
          <li v-if="smtShow || pcbShow" class="file-name">
            <strong>{{ MLANG.gerber_file }}: </strong>
            <template v-if="pcbFile.name">
                <span class="fc-xl fc-main">{{ pcbFile.name }}</span>
                <i
                  v-if="deletePcbIconShow"
                  @click="clearFiles('pcbFile')"
                  class="fs-xs mg-l-xs delete-icon"
                  >X</i
                >
            </template>
          </li>
          <li v-if="smtShow || bomShow" class="file-name">
            <strong>{{ MLANG.bom_file }}: </strong>
            <template v-if="bomFile.name">
              <span class="fc-xl fc-main">{{ bomFile.name }}</span>
              <i
                v-if="deleteBomIconShow"
                @click="clearFiles('bomFile')"
                class="fs-xs mg-l-xs delete-icon"
                >X</i
              >
            </template>
          </li>
          <li v-if="smtShow" class="file-name">
            <strong>{{ MLANG.centroid_file }}: </strong>
            <template v-if="centroidFile.name">
              <span class="fc-xl fc-main">{{ centroidFile.name }}</span>
              <i
                @click="clearFiles('centroidFile')"
                class="fs-xs mg-l-xs delete-icon"
                >X</i
              >
            </template>
          </li>
          <div
            v-if="uploadProcess !== 100"
            class="np-upload-preview_process mg-t-xs"
          >
            <p
              :style="{ width: uploadProcess + '%' }"
              class="np-upload-preview_width trans-animate"
            ></p>
          </div>
        </div>
      </div>
      <p class="fc-bs pd-t-xl">
        {{ MLANG.review_documents1 }}
        <strong class="f-bold">{{ MLANG.review_documents2 }}</strong>
        {{ MLANG.review_documents3 }}
      </p>
    </div>
  </confirm-modal>
</template>

<script>
import confirmModal from "@/_module/alert/confirm.vue";
import upload from "@/_module/upload/index.vue";
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    params: {
      type: Object,
      default: () => {
        return {
          page: "quote", // quote:计价页上传文件 cart：购物车上传文件
          service: "",
        };
      },
    },
  },
  components: {
    "np-upload": upload,
    "confirm-modal": confirmModal,
  },
  data() {
    return {
      pcbUploadOpts: {
        max: 1,
        maxsize: 50,
        maxSizeTip: this.MLANG.gerber_file_limit_tip,
        fileNameSize: [5, 100],
        fileNameSizeTip: this.MLANG.file_name_limit_tip,
        accept: ".zip,.rar",
        upfile: this.$api.upfile,
        multiple: false, //多文件上传
        showprocess: false,
        type: "pcbfile",
        disabledBtn: false,
      },
      bomUploadOpts: {
        max: 1,
        maxsize: 5,
        maxSizeTip: this.MLANG.bom_file_limit_tip,
        fileNameSize: [5, 100],
        fileNameSizeTip: this.MLANG.file_name_limit_tip,
        accept: ".xls,.xlsx,.csv",
        upfile: this.$api.upfile,
        multiple: false, //多文件上传
        showprocess: false,
        type: "bomfile",
      },
      centroidUploadOpts: {
        max: 1,
        maxsize: 50,
        maxSizeTip: this.MLANG.centroid_file_limit_tip,
        fileNameSize: [5, 100],
        fileNameSizeTip: this.MLANG.file_name_limit_tip,
        accept: ".zip,.rar",
        upfile: this.$api.upfile,
        multiple: false, //多文件上传
        showprocess: false,
        type: "attach",
      },
      confirmOptions: {
        area: ["860px", "500px"],
        title: "Upload File",
      },
      pcbFile: {},
      bomFile: {},
      centroidFile: {},
      uploadProcess: 0,
    }
  },
  computed: {
    // bom文件上传按钮是否显示
    bomShow() {
      if (this.params.page === "quote") {
        return this.params.service.split(",").includes("bom")
      } else {
        return this.params.bom_order_id
      }
    },
    // pcb文件上传按钮是否显示
    pcbShow() {
      if (this.params.page === "quote") {
        return this.params.service.split(",").includes("pcb") || this.params.service.split(",").includes("stencil")
      } else {
        return this.params.pcb_order_id || this.params.smd_order_id
      }
    },
    // 贴片文件上传按钮是否显示
    smtShow() {
      if (this.params.page === "quote") {
        return this.params.service.split(",").includes("assembly")
      } else {
        return this.params.smt_order_id
      }
    },
    // 删除pcb文件按钮是否显示
    deletePcbIconShow() {
      return !(this.params.pcbParsingFile && this.params.pcbParsingFile.fid) && !this.params.gerber_file_id
    },
    // 删除bom文件按钮是否显示
    deleteBomIconShow() {
      return !this.params.bom_file_id
    }
  },
  mounted() {
    if (this.params.page === "quote") {
      this.handleQuoteSubmit()
    } else {
      this.handleCartSubmit()
    }
  },
  methods: {
    // 购物车底部按钮处理
    handleCartSubmit() {
      this.confirmOptions.btns = [
        {
          text: this.LANG.cancel,
          callBack: () => {
            this.$emit("handleUploadFileSubmit")
          }
        },
        {
          text: this.LANG.submit,
          callBack: () => {
            console.log(242, this.params)
            if (
              (this.params.smt_order_id &&
                this.pcbFile.name &&
                this.bomFile.name &&
                this.centroidFile.name) ||
              (!this.params.smt_order_id && this.pcbFile.name)
            ) {
              this.$emit("handleUploadFileSubmit", "submit", {
                pcbFile: this.pcbFile,
                bomFile: this.bomFile,
                centroidFile: this.centroidFile,
              })
            } else {
              this.$alert.msg("Please upload the file before submitting.")
            }
          }
        },
      ]
      // 回显文件数据
      if (this.params.currentOrderData.pcb_file) {
        this.pcbFile = {
          fid: this.params.currentOrderData.pcb_file_id,
          name: this.params.currentOrderData.pcb_file_name,
          url: this.params.currentOrderData.pcb_file,
        }
      }
      if (this.params.currentOrderData.bom_file) {
        this.bomFile = {
          fid: this.params.currentOrderData.bom_file_id,
          name: this.params.currentOrderData.bom_file_name,
          url: this.params.currentOrderData.bom_file,
        }
      }
    },
    // 计价页底部按钮处理
    handleQuoteSubmit() {
      this.confirmOptions.btns = [
        {
          text: this.LANG.cancel,
          callBack: () => {
            this.$emit("handleUploadFileSubmit")
          }
        },
        {
          text: this.LANG.submit,
          callBack: () => {
            if (
              (this.params.service.split(",").includes("assembly") && this.pcbFile.name && this.bomFile.name && this.centroidFile.name) ||
              (!this.params.service.split(",").includes("assembly") && this.pcbFile.name)
            ) {
              // if (this.$store.getters.getTopData.cartCount + this.params.service.split(",").length >= 80 ) {
              //   this.$alert.msg("您的购物车太满了，请尽快清理购物车！")
              // }
              this.$emit("handleUploadFileSubmit", "submit", {
                pcbFile: this.pcbFile,
                bomFile: this.bomFile,
                centroidFile: this.centroidFile,
              })
            } else {
              this.$alert.msg("Please upload the file before submitting.")
            }
          }
        }
      ]
      console.log(340, this.params)
      // 回显pcb解析文件数据
      if (this.params?.pcbParsingFile?.fid) {
        this.pcbFile = this.params.pcbParsingFile
      }
      // 回显pcb文件
      if (this.params.gerber_file_id) {
        this.pcbFile = {
          fid: this.params.gerber_file_id,
          name: this.params.gerber_file_name,
          url: this.params.gerber_file
        }
      }
      // 回显bom文件
      if (this.params.bom_file_id) {
        this.bomFile = {
          fid: this.params.bom_file_id,
          name: this.params.bom_file_name,
          url: this.params.bom_file
        }
      }
    },
    // 删除文件
    clearFiles(type) {
      this[type] = {}
      this.$refs[type + "UploadRef"] && this.$refs[type + "UploadRef"].clearFile("all")
    },
    upfileProgress({ process }) {
      this.uploadProcess = process
    },
    fileUploadSuccess(fileData, type) {
      this[type] = fileData.res || {}
    },
    // 关闭弹框
    closeConfirm() {
      this.$emit("handleUploadFileSubmit")
    },
  },
}
</script>

<style lang="scss">
.upload-file-modal {
  .order-no {
    display: flex;
    padding: 10px 0;
    span {
      margin-right: 30px;
    }
  }
  .upload-file-btn-box {
    text-align: center;
    background-color: #ebebeb;
    border: 2px dashed #b2b2b2;
    height: 220px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    .upload-btn-wrap {
      width: 100%;
      display: flex;
      justify-content: space-around;
    }
    .upload-btn {
      width: 240px;
      height: 32px;
      line-height: 32px;
      text-align: center;
      border-radius: 3px;
      cursor: pointer;
      color: #fff;
    }
    .pcb-upload-btn {
      background-color: #ffad00;
    }
    .bom-upload-btn {
      background-color: #ff8231;
    }
    .centroid-upload-btn {
      background-color: #4d7bff;
    }
    .upload-icon {
      border-right: 1px solid #fff;
    }
    .disabled-upload-btn {
      background: #ccc;
      cursor: no-drop;
    }
    .file-name {
      line-height: 26px;
      .delete-icon {
        width: 16px;
        height: 16px;
        line-height: 16px;
        color: #fff;
        background: #999;
        border-radius: 50%;
        display: inline-block;
        cursor: pointer;
      }
    }
  }
}
</style>